export const FETCH_CHECKOUT_TERMS_REQUEST = 'FETCH_CHECKOUT_TERMS_REQUEST';
export const FETCH_CHECKOUT_TERMS_SUCCEEDED = 'FETCH_CHECKOUT_TERMS_SUCCEEDED';
export const FETCH_CHECKOUT_TERMS_FAILED = 'FETCH_CHECKOUT_TERMS_FAILED';
